import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.API_URL}/api/${process.env.API_VERSION}`,
  withCredentials: true,
});

instance.defaults.paramsSerializer = function (paramObj) {
  const params = new URLSearchParams();
  for (const key in paramObj) {
    if (Array.isArray(paramObj[key])) {
      paramObj[key].forEach(value => {
        params.append(key, value);
      });
    } else if (key === 'since') {
      const timezoneOffset = new Date().getTimezoneOffset() * 60000;
      paramObj[key] = new Date(new Date(paramObj[key]).setHours(0, 0, 0, 0) - timezoneOffset).toISOString().slice(0, -5);
      params.append(key, paramObj[key]);
    } else {
      params.append(key, paramObj[key]);
    }
  }
  return params.toString();
};

instance.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    const $router = window?.$nuxt.$router;
    if($router && error.response.status === 401 && !$router.currentRoute.name.includes('auth')) {
      window.location.pathname = '/auth/login';
    }else {
      return Promise.reject(error);
    }
  },
);

export default instance;
